export const Logo = ({ light = true, withWordmark = true }) => (
  <span className="inline-flex items-center gap-3 select-none">
    <svg
      width="30"
      height="30"
      viewBox="0 0 64 64"
      aria-hidden="true"
      className={light ? "text-bone" : "text-ink"}
    >
      <circle cx="32" cy="30" r="16" fill="none" stroke="currentColor" strokeWidth="2.4" />
      <line x1="32" y1="14" x2="32" y2="46" stroke="currentColor" strokeWidth="2.4" />
      <circle cx="32" cy="46" r="3.6" fill="#1F4D3A" />
    </svg>
    {withWordmark && (
      <span
        className={`font-mont text-base font-bold tracking-tight ${
          light ? "text-bone" : "text-ink"
        }`}
      >
        The Embodied Creator
      </span>
    )}
  </span>
);

export default Logo;
